import { axios, axiosWithoutHeaders } from "../../cores/axiosWrapper";
import queryString from "../../cores/queryString";

export function listResourceBuckets(apiEndpoint, stageId, projectId) {
    return axios.get(`${apiEndpoint}/resource-buckets`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function listResourceBucketsV2(apiEndpoint, stageId, projectId, params) {
    return axios.get(`${apiEndpoint}/project-storages/assigned-storages`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

export function putBulkResourceBuckets(apiEndpoint, stageId, projectId, data) {
    return axios.put(`${apiEndpoint}/resource-buckets/bulk`, data, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function listFolders(apiEndpoint, projectId, bucket, key) {
    const queries = {
        prefix: key || "",
    };
    return axios.get(`${apiEndpoint}/v3/directories/${bucket}/folders?${queryString.stringify(queries)}`, {
        headers: { projectId },
    });
}

export function listObjectsV3(apiEndpoint, projectId, bucket, key, condition) {
    const queries = condition.nextToken
        ? {
              prefix: key || "",
              nextToken: condition.nextToken,
          }
        : {
              prefix: key || "",
              key: condition.keyword,
              limit: condition.defaultViewCountByToken || 200,
          };

    return axios.get(`${apiEndpoint}/v3/directories/${bucket}/objects?${queryString.stringify(queries)}`, {
        headers: { projectId },
    });
}

export function mutate(apiEndpoint, stageId, stageVersion, projectId, bucketName, actions) {
    let requestBody = {
        ...actions,
    };
    let headers = {
        stageId,
        projectId,
    };
    let url = "";
    requestBody = Buffer.from(encodeURIComponent(JSON.stringify(requestBody))).toString("base64");

    headers = {
        ...headers,
        "x-mzc-content-encoding": "base64",
    };
    url = `${apiEndpoint}/v3/storages/buckets/${bucketName}/actions`;
    return axios.post(url, requestBody, {
        headers,
    });
}

export const StoragesApi = {
    listResourceBuckets,
    listResourceBucketsV2,
    putBulkResourceBuckets,
    listFolders,
    listObjectsV3,
    mutate,
};

export default StoragesApi;
